angular.module('charts')
  .directive("itemCarousel", function() {
    return {
      restrict: "E",
      scope: {
        itemwidth: '=',
        itemcount: '=',
        dynamicResize: '@',
        title: '@',
        pills: '@',
        tabs: '='
      },
      transclude: true,
      replace: false,
      templateUrl: '/resources/charts/partials/item-carousel.html',
      controller: ['$scope', '$element', '$window', '$rootScope', '$timeout', function($scope, $element, $window, $rootScope, $timeout) {
        var self = this;

        /* Grab itemWidth and itemCount from directive attributes, calculate item
         * widths, and initialize variables.
         */
        self.scrollContainer = $element.find('.scroll-container');
        self.itemCount = parseInt($scope.itemcount);
        self.itemWidth = parseInt($scope.itemwidth);
        self.nextItem = null;
        self.previousItem = null;
        self.container = null;
        self.previousLabel = $element.find('#previous-label');
        self.previousButton = $element.find('.previous');
        self.nextButton = $element.find('.next');
        self.nextLabel = $element.find('#next-label');
        self.numberOfItemsLeft = 0;
        self.numberOfItemsRight = 0;
        self.numberOfVisibleItems = 0;

        var updateContainerTimeout = function() {
          $timeout(function() {
            $scope.updateContainer();
          }, 0);
        };

        /* Update container when child items are done rendering */
        $scope.$on('carouselReload', function() {
          self.scrollContainer.css('left', '');
          updateContainerTimeout();
        });

        /* Wait for bound items to load - ajax - then update container */
        $scope.$watch('itemcount', updateContainerTimeout);

        /* Update the visible items, and button labels on resize */
        $rootScope.$watch('_width', updateContainerTimeout);

        /* updateContainer
         * Update the list of items currently in the container, calculate the current
         * container width along with the content size to figure out how
         * many items are visible, hidden to the left, and hidden to the right of the
         * visible content.
         */
        $scope.updateContainer = function() {
          self.items = self.scrollContainer.children();
          self.itemCount = parseInt($scope.itemcount);
          self.itemWidth = parseInt($scope.itemwidth);
          var left = parseInt(self.scrollContainer.css('left'));
          self.container = parseInt($element.find('.static-container').css('width'));

          self.numberOfVisibleItems = $window.Math.floor(self.container / self.itemWidth);
          self.numberOfVisibleItems = (self.numberOfVisibleItems > self.items.length) ? self.items.length : self.numberOfVisibleItems;
          self.numberOfItemsLeft = $window.Math.floor($window.Math.abs(left / self.itemWidth));
          self.numberOfItemsLeft = (self.numberOfItemsLeft >= $scope.itemcount) ? $scope.itemcount - 1 : self.numberOfItemsLeft;
          // if we have resized the window and the visible items + items to the left become more than the total items,
          // then we have to decrease the items to the left, otherwise we will end up with "empty" tabs
          self.numberOfItemsLeft = (self.numberOfItemsLeft + self.numberOfVisibleItems) > $scope.itemcount ? $scope.itemcount - self.numberOfVisibleItems : self.numberOfItemsLeft;
          self.numberOfItemsRight = self.itemCount - self.numberOfVisibleItems - self.numberOfItemsLeft;

          dynamicallyResizeElements();
          $scope.updateLabels();
        };

        var dynamicallyResizeElements = function() {
          if(self.items.length > 0 && $scope.dynamicResize) {
            // Update element size based on number of visible elements set by itemwidth.
            var newWidth = (self.container / self.numberOfVisibleItems);
            var newContainerWidth = (self.numberOfVisibleItems >= self.items.length) ? self.container : (newWidth * self.items.length);

            // IN-904 On Firefox when resize the last item can break on the next line.
            // Not obvious why this could be happening, possibly a rounding issue.
            // Adding one pixel to the container width fixes the issue (all items seem to fit)
            self.scrollContainer.css('width', newContainerWidth + 1);
            self.scrollContainer.css('left', self.numberOfItemsLeft * newWidth * -1);
            $timeout(function() {
              self.scrollContainer.children().each(function(index, item) {
                $(item).css('width', newWidth);
              });
            }, 10);
          }
        };

        /* updateLabels
         * Grab the next element in the carousel. If it has a data-label="test", then set
         * the next/previous label accordingly
         */
        $scope.updateLabels = function() {
          self.nextItem = $(self.items[self.numberOfVisibleItems + self.numberOfItemsLeft]);
          self.previousItem = $(self.items[self.numberOfItemsLeft - 1]);
          var nextLabel = self.nextItem.data('label') ? self.nextItem.data('label') : '';
          var prevLabel = self.previousItem.data('label') ? self.previousItem.data('label') : '';

          if (self.nextItem.length <= 0 ) {
            self.nextButton.addClass('disable');
          } else {
            self.nextButton.removeClass('disable');
          }

          if (self.previousItem.length <= 0) {
            self.previousButton.addClass('disable');
          } else {
            self.previousButton.removeClass('disable');
          }

          self.nextLabel.html(nextLabel);
          self.previousLabel.html(prevLabel);
        };

        /* previous
         * When the previous button is clicked, check to see if there are items to the left
         * if there are, update the scroll container offset to show the new item. Then update
         * the container - visible items / hidden items / button labels, etc.
         */
        $scope.previous = function() {

          if (self.numberOfItemsLeft > 0) {
            self.items = self.scrollContainer.children();

            self.scrollContainer.animate({
              left: (self.numberOfItemsLeft * self.itemWidth) - self.itemWidth
            }, 0, function() {
              $scope.updateContainer();
            });

          }
        };

        /* next
         * When the next button is clicked, check to see if there are items to the right
         * if there are, update the scroll container offset to show the new item. Then update
         * the container - visible items / hidden items / button labels, etc.
         */
        $scope.next = function() {

          if (self.numberOfItemsRight > 0) {
            self.items = self.scrollContainer.children();

            self.scrollContainer.animate({
              left: (self.numberOfItemsLeft * self.itemWidth) + self.itemWidth
            }, 0, function() {
              $scope.updateContainer();
            });

          }
        };

      }]
    };
  });
